<div class="header">
    <div class="back-arrow" *ngIf="showBackArrow">
      <p (click)="goBack()" class="pointer">
        <mat-icon>arrow_back</mat-icon>Volver
      </p>
    </div>
    <img src="../../../../assets/svg/logo-small.svg" alt="" />
  </div>
  